export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEOVW5pQ05TLVVURjE2LUhBBiATeAACEBuDvCmB1QaCC4HUVwEAYQcwCAGBFgABgRIAAYEaAAGBHgABgQ4CAYEKg51yAYEC", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/UniCNS-UTF16-V.bcmap
// module id = 689
// module chunks = 502